export const CAR_TYPE = { key: 'car', value: '汽車' };
export const MOTO_TYPE = { key: 'moto', value: '機車' };
export const TRAILER_TYPE = { key: 'trailer', value: '拖車' };

export const LICENSE_PLATE_TYPES = [CAR_TYPE, MOTO_TYPE, TRAILER_TYPE];
